<template>
  <div class="interface">
    <!-- 导航栏 -->
    <div class="navigation">
      <div class="back" @click="Previouspage()"><<<</div>
      <img :src="logUrlList.home" class="home_img" @click="Maininterface()" />
    </div>
    <div class="hint">{{ hint.headerHint }}</div>
    <div class="subject">
      <div class="header"></div>
      <div class="main">
        <div>
          <div
            class="imageDisplay"
            v-for="(item, index) in imgUrlList"
            :key="index"
          >
            <img class="imagePart" :src="item.xthumbPath" alt="" />
            <div class="imageInfo">
              <div class="time">时间：{{ item.createTime.split("T")[0] }}</div>
              <div class="name">{{ hint.imageHint }}</div>
              <div class="button01">
                <!-- <img
                  class="delButton"
                  :src="logUrlList.ele"
                  @click="toAIEditCardface(index)"
                /> -->
                <div class="delButton01" @click="toAIEditCardface(index)">
                  编辑
                </div>
                <img
                  class="delButton02"
                  :src="logUrlList.del"
                  @click="deleteImage(index)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer"></div>
    </div>
    <!-- 删除提示 -->
    <b-modal
      ref="model_error_del"
      title="提示"
      @ok="handleOk_del"
      ok-title="确定"
      cancel-title="取消"
      centered
    >
      <p class="my-4">{{ hint.del }}</p>
    </b-modal>
    <!-- 编辑提示 -->
    <b-modal
      ref="model_error_ele"
      title="提示"
      @ok="handleOk_ele"
      ok-title="确定"
      cancel-title="取消"
      centered
    >
      <p class="my-4">{{ hint.ele }}</p>
    </b-modal>
    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">{{ loadingInfo }}</p>
      </div>
    </div>
  </div>
</template>
<script>
const logUrl = require("@/common/logUrl");
const config = require("@/common/config");
import axios from "axios";
export default {
  name: "AICollection",
  data() {
    return {
      logUrlList: logUrl.logUrl,
      process: "",
      processCollection: 0,
      hint: {
        headerHint: "默认缓存100张，超出将会循环覆盖。",
        imageHint: "AI作品",
        // del: "是否删除此图片",
        del: "此功能暂未开放",
        ele: "是否编辑此图片",
      },
      index: "",
      imagePath: "",
      phone: "",
      taskId: "",
      style: "", //图生图style
      imgUrlList: [],
      loading: false,
      loadingInfo: "",
    };
  },
  methods: {
    Previouspage() {
      if (this.process == 0) {
        // 文生图
        this.$router.replace({
          name: "AItext_to_image",
          params: {
            taskId: this.taskId,
            phone: this.phone,
            backoff: 1,
          },
        });
      } else if (this.process == 1) {
        // 图文生图
        this.$router.replace({
          name: "AIimage_text_to_image",
          params: {
            taskId: this.taskId,
            phone: this.phone,
            backoff: 1,
            style: this.style,
            prompt: this.prompt,
          },
        });
      } else if (this.process == 2) {
        // 图生图
        this.$router.replace({
          name: "AIimage_to_image",
          params: {
            taskId: this.taskId,
            phone: this.phone,
            backoff: 1,
            style: this.style,
          },
        });
      } else {
        // 退回主页面
        this.$router.replace({
          name: "HomePage",
          params: {
            taskId: this.taskId,
            phone: this.phone,
            backoff: 1,
          },
        });
      }
    },
    Maininterface() {
      this.$router.push({
        name: "HomePage",
      });
    },
    // 去编辑
    toAIEditCardface(index) {
      this.index = index;
      this.showErrorMsg_ele();
    },
    // 删除
    deleteImage() {
      this.showErrorMsg_del();
    },
    handleOk_del: function (bvModalEvt) {},
    showErrorMsg_del: function () {
      this.$refs["model_error_del"].show();
    },
    hideErrorMsg_del: function () {
      this.$refs["model_error_del"].hide();
    },
    handleOk_ele: function (bvModalEvt) {
      this.pic2Base64();
    },
    showErrorMsg_ele: function () {
      this.$refs["model_error_ele"].show();
    },
    hideErrorMsg_ele: function () {
      this.$refs["model_error_ele"].hide();
    },
    pic2Base64() {
      this.loadingInfo = "去编辑...";
      this.loading = true;
      let param = {
        url: this.imgUrlList[this.index].imagePath,
      };
      console.log("pic2Base64--->", param);

      axios
        .post(config.config_demo.pic2Base64, param)
        .then((res) => {
          console.log("pic2Base64--->", res);
          this.imagePath = res.data.data.base64;
          this.toEditCardface();
        })
        .catch();
    },
    toEditCardface() {
      this.loadingInfo = "";
      this.loading = false;
      this.$router.replace({
        name: "AIEditCardface",
        params: {
          imagePath: this.imagePath,
          process: this.process,
          processCollection: this.processCollection,
        },
      });
    },
    getRecords() {
      let params = {
        phone: this.phone,
        taskId: "",
        isSave: 1, //收藏夹为1
      };
      axios.post(config.config_demo.getRecords, params).then((res) => {
        console.log("getRecords--->", res);
        if (res.data.code == 200) {
          this.imgUrlList = res.data.data;
          console.log("getRecords--->", this.imgUrlList);
        } else {
          console.log("系统错误");
        }
      });
    },
  },
  mounted() {
    this.phone = localStorage.getItem("phone");
    this.process = this.$route.params.process;
    this.taskId = this.$route.params.taskId;
    console.log(" this.taskId ", this.taskId);
    this.style = this.$route.params.style;
    this.prompt = this.$route.params.prompt;
    this.getRecords();
  },
};
</script>

<style scoped>
.navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  /* padding: 1.8rem 1.8rem 0; */
  padding: 4rem 1.8rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* .header {
  background-color: aqua;
  height: 3rem;
} */
.hint {
  position: fixed;
  z-index: 500;
  width: 100%;
  height: 2.6rem;
  background-color: #f9ecd0;
  color: red;
  font-size: 0.8rem;
  padding: 1.8rem 2rem;
  text-align: center;
}
/* .main {
  background-color: yellow;
  height: 3rem;
} */
.imageDisplay {
  width: 100%;
  height: 8rem;
  background-color: aliceblue;
  border-radius: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.8rem 0.8rem;
  margin-top: 0.8rem;
}
.imagePart {
  width: 40%;
  border-radius: 0.5rem;
}
.imageInfo {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 1rem;
}
.time {
  width: 10rem;
  font-size: 0.8rem;
  font-weight: 600;
}
.name {
  font-size: 1rem;
  font-weight: 600;
}
.button01 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.delButton01 {
  width: 2.4rem;
  height: 1.2rem;
  border-radius: 0.6rem;
  background-color: #3861d5;
  color: white;
  border-radius: 0.5rem;
  font-size: 0.8rem;
  text-align: center;
}
.delButton02 {
  width: 0.9rem;
  height: 1.4rem;
  /* border-radius: 0.6rem;
  background-color: #3861d5;
  color: white;
  border-radius: 0.5rem;
  font-size: 0.8rem;
  text-align: center; */
}
/* .footer {
  background-color: blue;
  height: 3rem;
} */
</style>



// WEBPACK FOOTER //
// src/components/DIYApplyCardSurface/ApplicationCard/AIProcess/AICollection.vue